@import "../../common-input";

:host {
  display: block;
}

/* URL-specific styles */
.input-container.invalid {
  border-color: var(--support-error);
}

.input-container.has-focus.invalid {
  box-shadow: 0 0 0 0.125rem var(--support-error);
}

.helper.invalid {
  color: var(--support-error-inverse);
}

.input-container {
  display: none;
}

.url-container {
  display: flex;

  goat-link {
    flex: 1;
  }
}

.editing {
  .url-container {
    display: none;
  }
  .input-container {
    display: flex;
  }
}